import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ProgressBar from '../../Common/ProgressBar/ProgressBar';
import GoalModal from './GoalModal';
import './CaseHeader.scss';

export default function CaseHeader() {
   return (
    <Row className="header-row mb-3">
      <Col sm='auto'>
        <h1>Activity Center</h1>
      </Col>
    </Row>
  )
}

CaseHeader.propTypes = {
  caseSummary: PropTypes.shape({
    totalPendingCaseAmount: PropTypes.number.isRequired,
    pendingStatusPremium: PropTypes.string.isRequired,
  }).isRequired
}

function SubmissionGoal(props) {

  const { submittedCount, submittedTitle, iconSrc, goalProgress, updateGoals, currentAppCount, currentPremiumCount } = props;

  const [goalModalOpen, setGoalModalOpen] = useState(false);

  return (
    <div className="case-goal">
      <div className="case-goal-count">
        <p className="case-count-number"><img src={iconSrc} alt="Submitted Apps" />&nbsp;{submittedCount}</p>
        <p className="case-title">{submittedTitle}</p>
      </div>
      {goalProgress ? <ProgressBar value={goalProgress} /> : <br />}
      <a className="case-title-goal" onClick={() => setGoalModalOpen(true)}>EDIT GOALS</a>
      <GoalModal
        open={goalModalOpen}
        setClosed={() => setGoalModalOpen(false)}
        updateGoals={updateGoals}
        currentAppCount={currentAppCount}
        currentPremiumCount={currentPremiumCount}
      />
    </div>
  );
}

SubmissionGoal.propTypes = {
  submittedCount: PropTypes.object.isRequired,
  submittedTitle: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/CaseHeader.js